import { Box, Alert } from "@mui/material";
import FileUploadZone from "../../postExamUpload/FileUploadZone";
import FilePreviewCard from "../../postExamUpload/FilePreviewCard";

const DescriptiveUploadPDF = ({
  currentSrNo,
  uploadState,
  onFileSelect,
  onDelete,
  onView,
  onRetry,
  disabled,
}) => {
  const { file, status, fileUrl, error } = uploadState ?? {};

  return (
    <Box sx={{ minHeight: "140px", pt: 1 }}>
      {error && !file && (
        <Alert severity="error" sx={{ mb: 1.5, py: 0.5, fontSize: "13px" }}>
          {error}
        </Alert>
      )}

      {!file ? (
        <FileUploadZone
          onFileSelect={(selectedFile, validationError) =>
            onFileSelect(currentSrNo, selectedFile, validationError)
          }
          disabled={disabled}
        />
      ) : (
        <FilePreviewCard
          file={file}
          status={status}
          fileUrl={fileUrl}
          onDelete={() => onDelete(currentSrNo)}
          onView={() => onView(fileUrl)}
          onRetry={() => onRetry(currentSrNo)}
          disabled={disabled}
        />
      )}
    </Box>
  );
};

export default DescriptiveUploadPDF;
